const classPrefix = 'breadcrumbs';
const dataPrefix = 'data-breadcrumbs';

const $container = document.querySelector(`[${dataPrefix}]`);

if ($container) {
    breadcrumbs($container);
}

function breadcrumbs(container) {


    init();

    function init(){

    }

}
